var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('Header', {
    attrs: {
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section'),
      "meta": _vm.meta
    }
  }), _c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("form_desc")) + " ")]) : _vm._e(), _c('div', {
    staticClass: "form"
  }, _vm._l(_vm.fields.filter(function (x) {
    return x.hidden == undefined || !x.hidden;
  }), function (field, index) {
    return _c('div', {
      key: "field.".concat(index, "}"),
      staticClass: "field"
    }, [field.type === 'name' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(" " + _vm._s(_vm.displayTitle(field, "姓名")) + " ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form.name,
        expression: "form.name"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form.name.$error
      },
      attrs: {
        "placeholder": _vm.displayPlaceholder(field, '請輸入您的姓名'),
        "disabled": field.disabled
      },
      domProps: {
        "value": _vm.form.name
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "name", $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e()]) : _vm._e(), field.type === 'mobile_phone' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(" " + _vm._s(_vm.displayTitle(field, "手機號碼")) + " ")]), _c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form.mobile_phone,
        expression: "form.mobile_phone"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form.mobile_phone.$error
      },
      attrs: {
        "type": "tel",
        "placeholder": _vm.displayPlaceholder(field, '請輸入您的手機號碼'),
        "disabled": field.disabled || _vm.isMobileValidating || _vm.mobileIsValid
      },
      domProps: {
        "value": _vm.form.mobile_phone
      },
      on: {
        "keypress": function keypress($event) {
          return _vm.v$.$touch();
        },
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "mobile_phone", $event.target.value);
        }
      }
    }), _vm.getModuleConfig('enable_sms_check') ? [_c('SharedButton', {
      staticClass: "ml-3 w-auto text-nowrap s-btn-bg-primary",
      attrs: {
        "disabled": !_vm.form.mobile_phone || _vm.v$.form.mobile_phone.$error || _vm.isMobileValidating || _vm.mobileIsValid
      },
      on: {
        "click": _vm.sendMobile
      }
    }, [_vm.isMobileValidating && _vm.counter > 0 ? [_vm._v(" " + _vm._s(_vm.counter) + "秒後失效 ")] : _vm.mobileIsValid ? [_vm._v("已驗証")] : [_vm._v(" 傳送驗證碼 ")]], 2), !_vm.isMobileValidating && !_vm.mobileIsValid && _vm.$store.state.liffAuth.user.phone_verified_at != null || _vm.isMobileValidating ? _c('button', {
      staticClass: "btn btn-link text-nowrap ml-3",
      on: {
        "click": function click() {
          _vm.isMobileValidating = false;
          _vm.mobileIsValid = _vm.$store.state.liffAuth.user.phone_verified_at != null;
          _vm.form.mobile_phone = _vm.$store.state.liffAuth.user.mobile_phone;
        }
      }
    }, [_vm._v(" 取消 ")]) : _vm._e(), _vm.mobileIsValid && !_vm.isMobileValidating ? _c('button', {
      staticClass: "btn btn-link text-nowrap ml-3",
      on: {
        "click": function click($event) {
          _vm.mobileIsValid = false;
        }
      }
    }, [_vm._v(" 修改 ")]) : _vm._e()] : _vm._e()], 2), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form.mobile_phone.$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 您輸入的格式有誤，請再次確認 ")]) : _vm._e(), _vm.mobileValidMessage ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(_vm.mobileValidMessage) + " ")]) : _vm._e(), _vm.v$.mobileIsValid.$invalid ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 手機號碼未驗証 ")]) : _vm._e(), _vm.isMobileValidating ? _c('div', {
      staticClass: "code-input d-flex"
    }, [_c('div', [_c('CodeInput', {
      class: {
        invalid: !_vm.codeIsValid
      },
      attrs: {
        "loading": false,
        "fields": 6,
        "fieldHeight": 80
      },
      on: {
        "change": function change(e) {
          return _vm.verificationCode = e;
        }
      }
    }), !_vm.codeIsValid ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(_vm.codeValidMessage) + " ")]) : _vm._e()], 1), _c('div', {
      staticClass: "flex-fill ml-2"
    }, [_c('SharedButton', {
      staticClass: "text-nowrap s-btn-bg-primary p-2 my-2",
      attrs: {
        "disabled": _vm.verificationCode.length != 6
      },
      on: {
        "click": _vm.verifyMobile
      }
    }, [_vm._v("確定")])], 1)]) : _vm._e()]) : _vm._e(), field.type === 'email' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(" " + _vm._s(_vm.displayTitle(field, "電子信箱")) + " ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form.email,
        expression: "form.email"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form.email.$error
      },
      attrs: {
        "type": "tel",
        "placeholder": _vm.displayPlaceholder(field, '請輸入您的電子信箱'),
        "readonly": field.disabled
      },
      domProps: {
        "value": _vm.form.email
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "email", $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form.email.$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 您輸入的格式有誤，請再次確認 ")]) : _vm._e()]) : _vm._e(), field.type === 'date' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(" " + _vm._s(field.title) + " ")]), _c('div', {
      staticClass: "field__select-group",
      class: {
        invalid: _vm.v$.form["".concat(field.field_key, "-year")].$error || _vm.v$.form["".concat(field.field_key, "-month")].$error || _vm.v$.form["".concat(field.field_key, "-day")].$error
      }
    }, [_c('SharedSelect', {
      attrs: {
        "options": _vm.yearOptions,
        "hasBorder": false,
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-year")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-year"), $$v);
        },
        expression: "form[`${field.field_key}-year`]"
      }
    }), _c('SharedSelect', {
      attrs: {
        "options": _vm.monthOptions,
        "hasBorder": false,
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-month")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-month"), $$v);
        },
        expression: "form[`${field.field_key}-month`]"
      }
    }), _c('SharedSelect', {
      attrs: {
        "options": _vm.dayOptions(_vm.form["".concat(field.field_key, "-year")], _vm.form["".concat(field.field_key, "-month")]),
        "hasBorder": false,
        "placeholder": "日",
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-day")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-day"), $$v);
        },
        expression: "form[`${field.field_key}-day`]"
      }
    })], 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form["".concat(field.field_key, "-year")].$error || _vm.v$.form["".concat(field.field_key, "-month")].$error || _vm.v$.form["".concat(field.field_key, "-day")].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : _vm._e(), field.type === 'address' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(" " + _vm._s(_vm.displayTitle(field, "地址")) + " ")]), _c('div', {
      staticClass: "field__select-group mb-3 city-selector-set-has-value"
    }, [_c('SharedSelect', {
      attrs: {
        "hasBorder": false,
        "selectClass": "county",
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-city")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-city"), $$v);
        },
        expression: "form[`${field.field_key}-city`]"
      }
    }), _c('SharedSelect', {
      attrs: {
        "hasBorder": false,
        "selectClass": "district",
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-district")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-district"), $$v);
        },
        expression: "form[`${field.field_key}-district`]"
      }
    })], 1), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form["".concat(field.field_key, "-address")],
        expression: "form[`${field.field_key}-address`]"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form["".concat(field.field_key, "-address")].$error || _vm.v$.form["".concat(field.field_key, "-district")].$error || _vm.v$.form["".concat(field.field_key, "-city")].$error
      },
      attrs: {
        "placeholder": "請輸入詳細地址",
        "disabled": field.disabled
      },
      domProps: {
        "value": _vm.form["".concat(field.field_key, "-address")]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "".concat(field.field_key, "-address"), $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e()]) : _vm._e(), field.type === 'text' && field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.field_key],
        expression: "form[field.field_key]"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form[field.field_key].$error
      },
      attrs: {
        "placeholder": _vm.displayPlaceholder(field),
        "disabled": field.disabled
      },
      domProps: {
        "value": _vm.form[field.field_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.field_key, $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : _vm._e(), field.type === 'select' && field.matched_key && !field.provider ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('SharedSelect', {
      attrs: {
        "options": field.options,
        "hasBorder": false,
        "placeholder": _vm.displayPlaceholder(field),
        "disabled": field.disabled
      },
      model: {
        value: _vm.form[field.field_key],
        callback: function callback($$v) {
          _vm.$set(_vm.form, field.field_key, $$v);
        },
        expression: "form[field.field_key]"
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()], 1) : field.type === 'branch' && field.matched_key && field.provider ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('ShopSelection', {
      ref: "shop-selection-".concat(field.field_key),
      refInFor: true,
      attrs: {
        "branch-provider": field.provider,
        "show-branch-code": !!field.show_branch_code,
        "placeholder": _vm.displayPlaceholder(field, '請選擇分店櫃點')
      },
      model: {
        value: _vm.form["".concat(field.field_key)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key), $$v);
        },
        expression: "form[`${field.field_key}`]"
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()], 1) : _vm._e(), field.type === 'radio' && field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "s-flex flex-wrap",
      class: field.is_vertical && 'flex-column'
    }, _vm._l(field.options, function (option, index) {
      return _c('SharedRadioButton', {
        key: field.title + index,
        attrs: {
          "id": field.title + index,
          "value": option.value,
          "name": field.matched_key,
          "disabled": field.disabled
        },
        model: {
          value: _vm.form[field.field_key],
          callback: function callback($$v) {
            _vm.$set(_vm.form, field.field_key, $$v);
          },
          expression: "form[field.field_key]"
        }
      }, [_vm._v(" " + _vm._s(option.text) + " ")]);
    }), 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : field.type === 'checkbox' && field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "s-flex"
    }, [_c('b-form-checkbox-group', {
      attrs: {
        "options": field.options,
        "stacked": field.is_vertical,
        "disabled": field.disabled
      },
      model: {
        value: _vm.form[field.field_key],
        callback: function callback($$v) {
          _vm.$set(_vm.form, field.field_key, $$v);
        },
        expression: "form[field.field_key]"
      }
    })], 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : _vm._e()]);
  }), 0), _vm.getModuleConfig('bind_branch_section.enable') ? _c('div', [_vm.getModuleConfig('bind_branch_section.title') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig('bind_branch_section.title')) + " ")]) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customerBranchName,
      expression: "customerBranchName"
    }],
    staticClass: "px-3 field__input text-center",
    attrs: {
      "placeholder": _vm.getModuleConfig('bind_branch_section.no_bind_branch_text'),
      "disabled": ""
    },
    domProps: {
      "value": _vm.customerBranchName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.customerBranchName = $event.target.value;
      }
    }
  }), !_vm.customerBranch.is_bind ? _c('SharedButton', {
    staticClass: "mt-2 mb-2 px-3 w-full text-nowrap s-btn-outline-primary",
    attrs: {
      "disabled": !_vm.getModuleConfig('bind_branch_section.allow_change_branch') && _vm.customerBranch.is_bind
    },
    on: {
      "click": _vm.redirectToBranchPicker
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig('bind_branch_section.bind_button_text')) + " "), _c('span', {
    staticClass: "mdi mdi-open-in-new"
  })]) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "reminder"
  }, [_vm._v(_vm._s(_vm.getModuleConfig("reminder_text")))]), _c('div', {
    staticClass: "page__button"
  }, [_c('MemberButton', {
    ref: "memberButton",
    attrs: {
      "button-text": _vm.getModuleConfig('button_text') || '確定儲存',
      "button-url": _vm.getModuleConfig('button_url'),
      "type": _vm.getModuleConfig('done_action'),
      "disable-default-click": true
    },
    on: {
      "custom-click": _vm.handleSubmit
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }